<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >

    <template>
      <v-card flat>
        <custom-tabs v-model="tabs" grow>
          <template v-slot:staticTabs>
            <v-tab>
              <div class="cornel-left" />
              <div class="cornel-right" />
              {{ $t("image_logo") }}
              <help-info
                :element-name="`${serviceName}-${componentName}-photo-logo-tab`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('image_logo')"
              />
            </v-tab>

            <v-tab :disabled="!containFields">
              <div class="cornel-left" />
              <div class="cornel-right" />
              {{ $t("image_gallery") }}
              <help-info
                :element-name="`${serviceName}-${componentName}-gallery-image-tab`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('image_gallery')"
              />
            </v-tab>
          </template>

          <template v-slot:middle>
            <div class="pt-4" />
          </template>

          <template v-slot:staticItems>
            <v-tab-item>
              <v-row no-gutters>
                <v-col
                  v-if="
                    !!valueComputed &&
                    valueComputed.hasOwnProperty('background')
                  "
                  class="pa-2"
                  cols="12"
                >
                  <v-card-title class="pb-0">
                    {{ $t("header_image") }}
                  </v-card-title>

                  <pic-selector
                    :disabled="
                      !!category.field && category.field === 'background'
                    "
                    :edit-img="false"
                    :edit-name="false"
                    :field.sync="valueComputed.headBackground"
                    :default-cat-name="$t('template_background_image')"
                    one-pic
                    single
                    :transparent.sync="valueComputed.headTransparent"
                  />
                </v-col>

                <v-col v-if="containFields" class="pa-2" cols="12">
                  <v-card-title class="pb-0">
                    {{ $t("background_image") }}
                  </v-card-title>

                  <pic-selector
                    :disabled="
                      !!category.field && category.field === 'headBackground'
                    "
                    :edit-img="false"
                    :edit-name="false"
                    :field.sync="valueComputed.background"
                    :default-cat-name="$t('background_image_alt')"
                    one-pic
                    single
                    :transparent.sync="valueComputed.backgroundTransparent"

                  />
                </v-col>

                <v-col class="pa-2" cols="12">
                  <v-card-title class="pb-0">
                    {{ $t("logo_upload") }}
                  </v-card-title>

                  <pic-selector
                    :disabled="!!category.field && category.field === 'profile'"
                    :edit-img="false"
                    :edit-name="false"
                    :field.sync="valueComputed.profile"
                    :default-cat-name="$t('logo')"
                    one-pic
                    single
                  />
                </v-col>

                <!-- <v-col class="pa-2" cols="12">
                  <v-switch
                    v-if="containFields"
                    v-model="hasWelcome"
                    class="mt-0 mb-2"
                    hide-details
                    :label="$t('welcome_image')"
                  />
                </v-col> -->

                <!-- <template v-if="hasWelcome">
                  <v-col class="pa-2" cols="12">
                    <v-card-title class="py-0">
                      {{ $t('welcome_image_logo_upload') }}
                    </v-card-title>

                    <pic-selector
                      v-if="hasWelcome"
                      v-model="welcomeGallery"
                      :edit-img="false"
                      :edit-name="false"
                      :field.sync="valueComputed.welcome"
                      :default-cat-name="$t('welcome')"
                      one-pic
                      single
                    />
                  </v-col>

                  <v-col class="pa-2" cols="12">
                    <label for="transition">{{ $t('loading_animation') }}</label>
                    <div class="rowinfo">
                      <v-select
                        id="transition"
                        v-model="transition"
                        :items="transitionItems"
                        :menu-props="{ offsetY: true }"
                        dense
                        outlined
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-transition`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        :label="$t('loading_animation')"
                      />
                    </div>
                  </v-col>

                  <v-col class="pa-2" cols="12">
                    <div class="rowinfo">
                      <v-btn
                        color="indigo"
                        class="contentinfo"
                        outlined
                        small
                        text
                        @click="showWelcome = !showWelcome"
                      >
                        {{ $t('preview_welcome_page') }}
                      </v-btn>
                      <help-info
                        :element-name="`${serviceName}-${componentName}-transition`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        :label="$t('preview')"
                      />
                    </div>
                  </v-col>
                </template> -->
              </v-row>
            </v-tab-item>

            <v-tab-item v-if="containFields">
              <pic-selector
                v-model="valueComputed.gallery"
                :single="!excludeNameSingle.includes($route.name)"
                :default-cat-name="$t('gallery')"
              />
            </v-tab-item>
          </template>
        </custom-tabs>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import { Bus, rbAxios } from "@/main";
import PicSelector from "../../../components/UploadCenter/picSelector";
import PicSelectorSingle from "../../../components/UploadCenter/picSelectorSingle";
import CatToUpload from "../../../components/UploadCenter/catToUpload";

export default {
  name: "imageUploader2",

  components: { CatToUpload, PicSelectorSingle, PicSelector },

  props: {
    value: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "imageUploader2",
      url: process.env.VUE_APP_ROBOT,
      tabs: 0,
      category: {
        name: "",
        field: "",
      },
      profile: null,

      welcomeImg: this.valueComputed?.welcome || null,
      loading: false,
      wloading: false,
      showWelcome: false,
      transition: "scale",
      fieldsInclude: [
        "qr.photo",
        "qr.id.editPhoto",
        "qr.name.id.editPhoto",
        "qr.name.editPhoto",
        "qr.id.editVideo",
        "qr.name.editVideo",
        "qr.name.id.editVideo",
        "qr.video",
        "qr.id.editSocial",
        "qr.socialMedia",
        "qr.name.editSocial",
        "qr.name.id.editSocial",
        'qr.create.photoGalleryModel',
        'qr.create.photoGalleryedit',
        'qr.create.editSocialModel',
        'qr.create.SocialMediaModel',


      ],
      photo: {
        background: "",
        profile: "",
        headBackground: "",
      },
      profileGallery: [{ name: "", images: [] }],
      backgroundGallery: [{ name: "", images: [] }],
      welcomeGallery: [{ name: "", images: [] }],
      hasWelcome: false,
      excludeNameSingle: [
        "qr.name.product",
        "qr.name.id.product",
        "qr.product.shop",
        "qr.product.edit",
      ],
    };
  },

  mounted() {
    this.$root.$on("clearDefaultData", this.clearDefaults);

    this.photo.profile = this.profile =
      this.value?.profile ||
      this.$coreApi3 + "/storage/s5wXoRhzyw9PkGXA8qnIL2yvA3TPiXhwsFrwjmeX.png";
    this.photo.welcome = this.welcomeImg = this.value?.welcome || null;
    this.photo.headBackground =
      this.value?.headBackground || "/media/business/faq/faq-1.webp";
    this.transition = this.value?.transition || "scale";
    this.hasWelcome = this.value?.hasWelcome || false;
  },

  computed: {
    rules() {
      return {
        image: [
          (value) =>
            !value || value.size < 2000000 || this.$t("max_background_size"),
        ],
        logo: [
          (value) => !value || value.size < 2000000 || this.$t("max_logo_size"),
        ],
      };
    },
    transitionItems() {
      return [
        { text: this.$t("scale_from_center"), value: "scale" },
        { text: this.$t("slide_from_left"), value: "slideX" },
        { text: this.$t("slide_from_top"), value: "slideY" },
        { text: this.$t("fade"), value: "fade" },
      ];
    },
    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        this.$forceUpdate();
      },
    },
    containFields() {
      return !this.fieldsInclude.includes(this.$route.name);
    },
  },

  watch: {
    hasWelcome(val) {
      this.valueComputed.hasWelcome = val;
    },
    transition(val) {
      this.valueComputed.transition = val;
    },
    showWelcome: {
      handler(val) {
        Bus.$emit("showMe", val);
      },
      immediate: true,
      deep: true,
    },
    backgroundGallery: {
      deep: true,

      handler(val) {
        if (val[0] && val[0].images && val[0].images.length > 0) {
          this.valueComputed.headBackground = "";

          this.$nextTick(() => {
            this.valueComputed.headBackground = val[0].images[0].url;
          });
        } else {
          this.valueComputed.headBackground = null;
        }
      },
    },
    profileGallery: {
      deep: true,

      handler(val) {
        if (val[0] && val[0].images && val[0].images.length > 0) {
          this.photo.profile = "";
          this.profile = null;

          this.$nextTick(() => {
            this.valueComputed.profile = val[0].images[0].url;
          });
        } else {
          this.photo.profile = "";
          this.valueComputed.profile = null;
        }
      },
    },
    welcomeGallery: {
      deep: true,

      handler(val) {
        if (val[0] && val[0].images && val[0].images.length > 0) {
          this.welcomeImg = "";
          this.valueComputed.welcome = "";

          this.$nextTick(() => {
            this.valueComputed.welcome = val[0].images[0].url;
          });
        } else {
          this.welcomeImg = "";
          this.valueComputed.welcome = null;
        }
      },
    },
  },

  methods: {
    clearDefaults() {
      this.photo = {
        profile: null,
        welcome: null,
        transition: "scale",
        hasWelcome: false,
        hasGif: false,
        hasGame: false,

        previewerQr: {
          previewer: {
            gif: "",
            game: {},
            transition: "scale",
          },
        },
      };
      this.profile = null;
      this.welcomeImg = null;
      this.transition = "scale";
      this.hasWelcome = false;
    },
  },
};
</script>

<style scoped></style>
